import styled from 'styled-components';

export const PreviewBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1031;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.85);
  animation: opacityFromNone 0.2s ease-out;
`;

export const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: ${({ $isImage }) => ($isImage ? '600px' : 'calc((100vh - 200px) * 16 / 9)')};
  animation: slideIn 0.3s ease-out;
`;

export const PreviewHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  color: #fff;
`;

export const PreviewHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const PreviewTitle = styled.h1`
  margin: 0;
  font-size: 20px;
  line-height: 20px;
  font-weight: bold;
  color: #fff;
`;

export const PreviewSubTitle = styled.p`
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PreviewClose = styled.button`
  flex-shrink: 0;
  background: transparent;
  border: 0;
  outline: none;
  padding: 4px;
  color: #fff;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
  }

  &:focus-visible {
    outline: 2px solid rgba(255, 255, 255, 0.6);
    outline-offset: 2px;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const PreviewMedia = styled.div`
  width: 100%;
`;

export const PreviewImage = styled.img`
  display: block;
  width: 100%;
  max-height: calc(100vh - 220px);
  object-fit: contain;
`;

export const PreviewIframe = styled.iframe`
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  border: 0;
  border-radius: 8px;
  background: #000;
`;
